import axios from '../http.js'

//平台检索列表
function getSearchList(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/queryCourseSearchPage',
    method: 'post',
    data: data
  })
}
//课程类别详情 courseCategoryId： 1实验室，2普通
function courseCategoryDetail(data) {
  return axios.baseAxios({
    url: '/backstage/courseCategoryDetail/queryTree',
    method: 'post',
    params: data
  })
}
//课程详情
function getCourseDetail(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/queryCourseDetail',
    method: 'post',
    params: data
  })
}

//课程分页（创课中心）
function getCourseList(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/queryCoursePage',
    method: 'post',
    data: data
  })
}
//发布/撤销发布
function publishOrUnPublish(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/publishOrUnPublish',
    method: 'post',
    params: data
  })
}
//删除课程
function delCourse(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/deleteCourse',
    method: 'post',
    params: data
  })
}
//创建课程
function createCourse(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/createCourse',
    method: 'post',
    data: data
  })
}
//编辑课程基本信息
function editCourseBaseInfo(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/editCourseBaseInfo',
    method: 'post',
    data: data
  })
}
//编辑课程设计
function editCourseDesign(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/editCourseIntroduction',
    method: 'post',
    data: data
  })
}
//删除课程
function deleteCourse(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/deleteCourse',
    method: 'post',
    params: data
  })
}
//添加课程公告
function addCourseNotice(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/addCourseNotice',
    method: 'post',
    data: data
  })
}
//删除课程公告
function delCourseNotice(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/deleteCourseNotice',
    method: 'post',
    params: data
  })
}
//课程公告分页
function getCourseNoticeList(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/queryCourseNoticePage',
    method: 'post',
    data: data
  })
}
//课程详情里的课程公告
function getCourseNoticePageForCourseDetail(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/queryCourseNoticePageForCourseDetail',
    method: 'post',
    data: data
  })
}

//绑定虚仿资源
function bindLabAccessResource(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/bindLabAccessResource',
    method: 'post',
    data: data
  })
}
//绑定虚仿资源(普通课)
function bindLabNormalAccessResource(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/bindLabNormalAccessResource',
    method: 'post',
    data: data
  })
}
//编辑学习设置
function editCourseStudySetting(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/editCourseStudySetting',
    method: 'post',
    data: data
  })
}

//编辑学习设置
function getCourseImportanceList() {
  return axios.baseAxios({
    url: '/backstage/enums/getCourseImportanceList',
    method: 'get'
  })
}
//获取树状列表
function getTreeList(courseId) {
  return axios.baseAxios({
    url: '/backstage/courseManage/getNormalClassTreeList?courseId=' + courseId,
    method: 'get'
  })
}
//保存资源分组
function saveGroup(data) {
  return axios.baseAxios({
    url: '/backstage/courseManage/saveGroup',
    method: 'post',
    data:data
  })
}
//删除资源分组
function deleteGroup(id) {
  return axios.baseAxios({
    url: '/backstage/courseManage/deleteGroup?id=' + id,
    method: 'get'
  })
}
function uploadFile(data) {
  return axios.formDataAxios({
    url: '/backstage/courseManage/uploadLargeFileClass',
    method: 'post',
    data:data
  })
}
export default {
  getSearchList,
  courseCategoryDetail,
  getCourseDetail,
  getCourseList,
  publishOrUnPublish,
  delCourse,
  createCourse,
  editCourseBaseInfo,
  editCourseDesign,
  deleteCourse,
  addCourseNotice,
  delCourseNotice,
  getCourseNoticeList,
  getCourseNoticePageForCourseDetail,
  bindLabAccessResource,
  bindLabNormalAccessResource,
  editCourseStudySetting,
  getCourseImportanceList,
  getTreeList,
  saveGroup,
  deleteGroup,
  uploadFile
}


// WEBPACK FOOTER //
// ./src/api/modules/courseManage.js